import { AuthenticationService } from './services/authentication.service';
import { ActivatedRoute } from '@angular/router';
import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class AppInitService {
  constructor(private authenticationService: AuthenticationService, private route: ActivatedRoute) {}

  init(): void {
    console.log("App initialization logic goes here");
    const segments = this.route.snapshot.url;
    const routePath = segments.map(segment => segment.path).join('/');
    console.log(routePath);
    var userLoggedIn  = this.authenticationService.isLoggedIn();
    if (userLoggedIn) {
      console.log('yay, user logged in')
    } 
  }
}
